import { userConstants } from '../constants';
import { getStoredUserWithValidSession } from '../helpers/authUtils';

function getInitialUser() {
    return getStoredUserWithValidSession();
}

const initialState = (() => {
    const user = getInitialUser();
    return user ? { loggedIn: true, user } : {};
})();

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    case userConstants.UPDATE_USER:
      return action.user ? { ...state, loggedIn: true, user: action.user } : state;
    default:
      return state
  }
}
